__webpack_require__.p = "/s/activity/vip-gift/";